import { AppLayout } from "../shared";
import Userdetail from "../userdetail/userdetail";

const Usersdetails_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <Userdetail props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default Usersdetails_layout;